export default __webpack_public_path__ + "static/media/woman.ac31a3e9.png";